module.exports = require("./../../_gen/openfl/desktop/Clipboard");